import { createSlice } from "@reduxjs/toolkit";

import {
  getInsightsAdvancedAction,
  getInsightsAdvancedExpenseAction,
  getInsightsAdvancedSalesAction,
  profitLossAction,
} from "@/redux/insightsAdvanced/actions";
import { initialState } from "@/redux/insightsAdvanced/initialState";
import type { InsightsAdvancedTypes } from "@/redux/insightsAdvanced/insightAdvanceTypes";
import { insightAdvancedReducer } from "@/redux/insightsAdvanced/reducer";

export const insightAdvanceSlice = createSlice({
  name: "insightAdvance",
  initialState,
  reducers: insightAdvancedReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getInsightsAdvancedAction.pending,
      (state: InsightsAdvancedTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getInsightsAdvancedAction.fulfilled,
      (state: InsightsAdvancedTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          insightsAdvancedListData: result,
        };
      }
    );

    builder.addCase(
      getInsightsAdvancedAction.rejected,
      (state: InsightsAdvancedTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      profitLossAction.pending,
      (state: InsightsAdvancedTypes) => ({
        ...state,
        profitLossAction: true,
      })
    );

    builder.addCase(
      profitLossAction.fulfilled,
      (state: InsightsAdvancedTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            profitLossAction: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          profitLossAction: false,
          statusCode: status_code,
          profitLossData: result,
        };
      }
    );

    builder.addCase(
      profitLossAction.rejected,
      (state: InsightsAdvancedTypes, { error }) => ({
        ...state,
        profitLossAction: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getInsightsAdvancedSalesAction.pending,
      (state: InsightsAdvancedTypes) => ({
        ...state,
        totalSalesFetching: true,
      })
    );

    builder.addCase(
      getInsightsAdvancedSalesAction.fulfilled,
      (state: InsightsAdvancedTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            totalSalesFetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          totalSalesFetching: false,
          statusCode: status_code,
          totelSales: result,
        };
      }
    );

    builder.addCase(
      getInsightsAdvancedSalesAction.rejected,
      (state: InsightsAdvancedTypes, { error }) => ({
        ...state,
        totalSalesFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getInsightsAdvancedExpenseAction.pending,
      (state: InsightsAdvancedTypes) => ({
        ...state,
        totalExpenseFetching: true,
      })
    );

    builder.addCase(
      getInsightsAdvancedExpenseAction.fulfilled,
      (state: InsightsAdvancedTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            totalExpenseFetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          totalExpenseFetching: false,
          statusCode: status_code,
          totelExpense: result,
        };
      }
    );

    builder.addCase(
      getInsightsAdvancedExpenseAction.rejected,
      (state: InsightsAdvancedTypes, { error }) => ({
        ...state,
        totalExpenseFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
  },
});

export const {
  resetInsightAdvancedError,
  resetInsightAdvancedSuccess,
  resetInsightAdvancedListData,
  resetInsightAdvancedFetching,
  resetProfiltLossData,
  resetTotelSales,
  resetTotalExpenses,
} = insightAdvanceSlice.actions;
